import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class InstanceTypeInterceptor implements HttpInterceptor {
  constructor(@Inject('env') private env: any) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let clonedRequest, headers;

    if (this.env.instanceType !== undefined)
      headers = request.headers.append('PortalInstance', this.env.instanceType.toString());
    else headers = request.headers;

    clonedRequest = request.clone({ headers: headers });
    return next.handle(clonedRequest);
  }
}
